import SectionMessage from '@atlaskit/section-message';
import PremiumIcon from '@atlaskit/icon/core/premium';
import settingsDo from "../../../../../../packages/design-system/icon/constellation/index/images/settings-do-light.png";
import settingsDoDark from "../../../../../../packages/design-system/icon/constellation/index/images/settings-do-dark.png";
import settingsDont from "../../../../../../packages/design-system/icon/constellation/index/images/settings-dont-light.png";
import settingsDontDark from "../../../../../../packages/design-system/icon/constellation/index/images/settings-dont-dark.png";
import menuDo from "../../../../../../packages/design-system/icon/constellation/index/images/menu-do-light.png";
import menuDoDark from "../../../../../../packages/design-system/icon/constellation/index/images/menu-do-dark.png";
import menuDont from "../../../../../../packages/design-system/icon/constellation/index/images/menu-dont-light.png";
import menuDontDark from "../../../../../../packages/design-system/icon/constellation/index/images/menu-dont-dark.png";
import iconTileLight from "../../../../../../packages/design-system/icon/constellation/index/images/icon-tile-light.png";
import iconTileDark from "../../../../../../packages/design-system/icon/constellation/index/images/icon-tile-dark.png";
import iconSpacing from "../../../../../../packages/design-system/icon/constellation/index/images/icon-spacing-light.png";
import iconSpacingDark from "../../../../../../packages/design-system/icon/constellation/index/images/icon-spacing-dark.png";
import iconSmall from "../../../../../../packages/design-system/icon/constellation/index/images/small-icons-light.png";
import iconSmallDark from "../../../../../../packages/design-system/icon/constellation/index/images/small-icons-dark.png";
import Image from '@atlaskit/image';
import * as React from 'react';
export default {
  SectionMessage,
  PremiumIcon,
  settingsDo,
  settingsDoDark,
  settingsDont,
  settingsDontDark,
  menuDo,
  menuDoDark,
  menuDont,
  menuDontDark,
  iconTileLight,
  iconTileDark,
  iconSpacing,
  iconSpacingDark,
  iconSmall,
  iconSmallDark,
  Image,
  React
};